import { Bot, Eye, MessageSquareDot, Lock } from "lucide-react";

const pillars = [
  {
    icon: Bot,
    title: "AI does the heavy lifting",
    body: "Segmentation, message generation, follow-ups — all automated. You don’t touch a tool, learn a dashboard, or hire a ’prompt engineer.’",
  },
  {
    icon: Eye,
    title: "You approve everything",
    body: "Nothing goes out until you green-light the messages, the offer, and the audience. Total transparency, zero surprises.",
  },
  {
    icon: MessageSquareDot,
    title: "Your voice, not a robot’s",
    body: "We interview you for 30 minutes and clone your tone. Recipients can’t tell the difference — because there isn’t one.",
  },
  {
    icon: Lock,
    title: "Your data stays yours",
    body: "We sign NDAs, work in your CRM, and never resell or repurpose your contacts. Ever.",
  },
];

export default function AIWithoutOverwhelm() {
  return (
    <section
      data-testid="ai-section"
      className="relative py-24 lg:py-32 border-b border-white/10 bg-[#070707]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.25em] text-[#ccff00] font-semibold mb-4">
              / AI without the overwhelm
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95]">
              You don’t need
              <br />
              another tool.
              <br />
              <span className="text-[#ccff00]">You need results.</span>
            </h2>
            <p className="mt-6 text-white/60 max-w-md leading-relaxed">
              Most agencies hand you a dashboard and a login. We hand you booked
              appointments and revenue reports. That’s the difference between AI
              and AI <em>done for you</em>.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {pillars.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  data-testid={`pillar-${i + 1}`}
                  className="bg-[#0a0a0a] p-6 lg:p-8 hover:bg-[#111] transition-colors"
                >
                  <Icon className="w-6 h-6 text-[#ccff00] mb-6" strokeWidth={1.5} />
                  <h3 className="font-display text-xl uppercase mb-3">
                    {p.title}
                  </h3>
                  <p className="text-sm text-white/60 leading-relaxed">
                    {p.body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
